export const orderTableHeaders = [
  { label: 'Instrument', key: 'instrument' },
  { label: 'Action / Order Type', key: 'type' },
  { label: 'Buy/Sell', key: 'buySell' },
  { label: 'Quantity', key: 'extraDetails.qty' },
  { label: 'Exec Price', key: 'extraDetails.tradedPrice' },
  { label: 'LTP', key: 'ltp' },
  { label: 'Status', key: 'status' },
];
